import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";
import { images } from "../data/images";

export default function Award() {
  const { t } = useLanguage();
  const tx = translations.award;

  return (
    <section className="relative h-[78vh] min-h-[600px] w-full overflow-hidden">
      <img
        src={images.realHouseNight}
        alt="NACUII illuminated facade at night"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/55" />

      {/* Refined award seal */}
      <div className="absolute top-1/2 right-6 lg:right-20 -translate-y-1/2 hidden md:block">
        <div className="relative w-[200px] h-[200px] lg:w-[240px] lg:h-[240px]">
          {/* Outer rotating ring */}
          <svg
            viewBox="0 0 200 200"
            className="absolute inset-0 w-full h-full animate-[spin_40s_linear_infinite]"
          >
            <defs>
              <path
                id="awardCircle"
                d="M 100, 100 m -85, 0 a 85,85 0 1,1 170,0 a 85,85 0 1,1 -170,0"
              />
            </defs>
            <text
              fill="#E5D6A8"
              style={{
                fontFamily: "'Jost', sans-serif",
                fontSize: "8.5px",
                letterSpacing: "5px",
                fontWeight: 400
              }}
            >
              <textPath href="#awardCircle" startOffset="0">
                {`${t(tx.badgeTop).toUpperCase()}  ·  NACUII  ·  ${t(tx.badgeBottom).toUpperCase()}  ·  TODOS SANTOS  ·  `}
              </textPath>
            </text>
          </svg>

          {/* Inner medal */}
          <div className="absolute inset-[18px] rounded-full border border-[#C9B789]/60 flex items-center justify-center">
            <div className="absolute inset-[6px] rounded-full border border-[#C9B789]/30" />
            <div className="text-center px-3">
              {/* Decorative top */}
              <div className="flex items-center justify-center gap-1.5 mb-3">
                <div className="h-px w-4 bg-[#C9B789]" />
                <svg width="14" height="14" viewBox="0 0 14 14" className="text-[#C9B789]">
                  <path
                    d="M7 1 L8.5 5.5 L13 7 L8.5 8.5 L7 13 L5.5 8.5 L1 7 L5.5 5.5 Z"
                    fill="currentColor"
                    opacity="0.85"
                  />
                </svg>
                <div className="h-px w-4 bg-[#C9B789]" />
              </div>

              <p
                className="text-[#E5D6A8] text-[8.5px] tracking-[0.35em] uppercase mb-1.5"
                style={{ fontFamily: "'Jost', sans-serif", fontWeight: 500 }}
              >
                Architecture
              </p>
              <p
                className="text-[#F5F0E8] text-[28px] lg:text-[34px] leading-none italic"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}
              >
                Award
              </p>
              <p
                className="text-[#F5F0E8] text-[26px] lg:text-[32px] leading-none mt-0.5"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500, letterSpacing: "0.06em" }}
              >
                MMXXVI
              </p>

              {/* Decorative bottom */}
              <div className="flex items-center justify-center gap-1.5 mt-3">
                <div className="h-px w-4 bg-[#C9B789]" />
                <span
                  className="text-[#C9B789] text-[8px] tracking-[0.3em]"
                  style={{ fontFamily: "'Jost', sans-serif", fontWeight: 500 }}
                >
                  EST. 2026
                </span>
                <div className="h-px w-4 bg-[#C9B789]" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 w-full">
          <div className="max-w-2xl">
            <p
              className="text-white/85 text-[11px] tracking-[0.45em] uppercase mb-6"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.eyebrow)}
            </p>
            <h2
              className="text-white text-[34px] sm:text-[48px] lg:text-[60px] leading-[1.1]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
            >
              {t(tx.title1)}
              <br />
              <em className="italic">{t(tx.title2)}</em>
            </h2>
            <div className="mt-10">
              <a
                href="#arquitectura"
                className="inline-flex items-center justify-center px-9 py-4 text-[11px] tracking-[0.3em] uppercase border border-white text-white hover:bg-white hover:text-[#2A2A28] transition-colors duration-300"
                style={{ fontFamily: "'Jost', sans-serif" }}
              >
                {t(tx.cta)}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
